import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import React, { useEffect, useState } from "react";
import {
  Alert,
  IconButton,
  InputAdornment,
  Rating,
  Stack,
  Typography,
  Paper,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Divider,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  DatePicker,
  DesktopDatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../constants/global";
import { useGeolocated } from "react-geolocated";
import LocationOn from "@mui/icons-material/LocationOn";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useAuth0 } from "@auth0/auth0-react";
import { Image } from "../models/Image";
import packageJson from "../../package.json";
import CloudYolo from "../components/CloudYolo";

export const YoloCloudAdd: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "ACTT | Add (yolo cloud)";
  }, []);
  const [error, setError] = useState(false);
  const { user, getAccessTokenSilently } = useAuth0();
  const {
    register,
    setValue,
    handleSubmit,
    control,
    getValues,

    formState: { errors },
  } = useForm<Image>({
    defaultValues: {
      authorId: 0,
      authorIdentity: "",
      fileName: "",
      address: "",
      siteId: "",
      descriptorId: undefined,
      weekId: undefined,
      uniqueImageId: "",
      sampleName: "",
      setUpDate: dayjs(),
      collectionDate: dayjs(),
      pictureDate: dayjs(),
      manualEggCount: undefined,
      species: "",
      hatchingDate: dayjs(),
      origin: "lab",
      type: "blank",
      heightPhoto: undefined,
      stand: "",
      anglePhoto: undefined,
      device: "",
      resolution: "",
      lightCondition: "dim",
      photoCondition: "indoor",
      paperType: "seed paper",
      paperColor: "white",
      paperCondition: "wet",
      waterType: "tap",
      trapType: "ovicup",
      deployTime: undefined,
      computedEggCount: 0,
      rating: null,
      note: "",
      clientInfo: "",
      timeStamp: null,
      analyzedResults: null
    },
  });

  const [locale, setLocale] = React.useState<string>("en");

  const [setUpDate, setSetUpDate] = React.useState<Dayjs | null>(dayjs());
  // useState<Date | null>(new Date());

  const [collectionDate, setCollectionDate] = React.useState<Dayjs | null>(
    dayjs()
  );

  const [pictureDate, setPictureDate] = React.useState<Dayjs | null>(dayjs());

  const [hatchingDate, setHatchingDate] = React.useState<Dayjs | null>(dayjs());

  const [fileName, setFileName] = useState<string>("");

  const [computedEggCount, setComputedEggCount] = useState<number | null>(null);

  const [imagesSubmitted, setImagesSubmitted] = useState<boolean>(false);

  const [analyzedResult, setAnalyzedResult] = useState<any>(null);

  const [additionalOptions, setAdditionalOptions] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [submitError, setSubmitError] = useState<string | null>(null);

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
    });
  const populateLocation = () => {
    setValue("address", coords?.latitude + ", " + coords?.longitude);
  };

  const [rating, setRating] = useState<number | null>(null);

  const onSubmit = async (event: any) => {
    setIsSubmitting(true);
    setSubmitError(null);
    const accessToken = await getAccessTokenSilently();
    console.log("updatedValues" + getValues());
    console.log(String(setUpDate));
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      setValue("authorIdentity", user?.email ? user?.email : "no_email");
      setValue("setUpDate", setUpDate ? setUpDate : dayjs());
      setValue("collectionDate", collectionDate ? collectionDate : dayjs());
      setValue("pictureDate", pictureDate ? pictureDate : dayjs());
      setValue("hatchingDate", hatchingDate ? hatchingDate : dayjs());
      setValue("authorId", 23);
      setValue("fileName", fileName);
      setValue("computedEggCount", computedEggCount ? computedEggCount : 0);
      setValue("rating", rating);
      setValue("analyzedResults", analyzedResult);
      setValue("clientInfo", "Web v" + packageJson.version + " YOLO Cloud");
      const body = JSON.stringify(getValues());
      console.log("Values" + body);
      const res = await axios.post(`${BASE_URL}/v1/image/`, body, config);
      console.log("Resulting data" + res.data);
      if (res.status === 200) {
        console.log("Status is " + res.status);
        navigate("/images");
      }
    } catch (e) {
      console.error(e);
      setSubmitError("Failed to submit image. Please try again.");
      setIsSubmitting(false);
    }
  };
  

  const origins = [
    {
      value: "field",
    },
    {
      value: "lab",
    },
  ];
  const types = [
    {
      value: "blank",
    },
    {
      value: "positive",
    },
    {
      value: "negative",
    },
  ];
  const lightConditions = [
    {
      value: "dim",
    },
    {
      value: "light",
    },
  ];
  const photoConditions = [
    {
      value: "indoor",
    },
    {
      value: "outdoor",
    },
  ];
  const paperTypes = [
    {
      value: "seed paper",
    },
    {
      value: "whatman paper",
    },
  ];
  const paperConditions = [
    {
      value: "wet",
    },
    {
      value: "dry",
    },
  ];
  const waterTypes = [
    {
      value: "tap",
    },
    {
      value: "other",
    },
  ];
  const trapTypes = [
    {
      value: "ovicup",
    },
    {
      value: "white remakin",
    },
  ];
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 3 }}>
          Count Mosquito Eggs (YOLO Cloud)
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 4 }}>
          Upload an image to analyze mosquito eggs using our cloud-based YOLO model
        </Typography>

        <Card variant="outlined" sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Step 1: Upload & Analyze Image
            </Typography>
            <CloudYolo
              setFileName={(fileName) => setFileName(fileName)}
              setComputedEggCount={(computedEggCount) =>
                setComputedEggCount(computedEggCount)
              }
              setImageSubmitted={(imagesSubmitted) =>
                setImagesSubmitted(imagesSubmitted)
              }
              setAnalyzedResult={(analyzedResult) => {
                setAnalyzedResult(analyzedResult);
              }}
            />
          </CardContent>
        </Card>

      </Paper>

      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
          Step 2: Sample Information
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={3}>
            {/* Required Fields Section */}
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Required Information</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={2}>
                  <Controller
                    control={control}
                    name="siteId"
                    defaultValue=""
                    render={() => (
                      <TextField
                        id="siteId"
                        {...register("siteId", { required: "Site Id is required" })}
                        label="Site Id"
                        variant="outlined"
                        fullWidth
                        required
                        error={!!errors.siteId}
                        helperText={errors.siteId?.message}
                      />
                    )}
                  />

                  <Controller
                    control={control}
                    name="descriptorId"
                    render={() => (
                      <TextField
                        id="descriptorId"
                        label="Descriptor Id"
                        type="number"
                        variant="outlined"
                        fullWidth
                        {...register("descriptorId", {
                          required: "Descriptor Id is required",
                          min: {
                            value: 1,
                            message: "Descriptor Id must be a positive value",
                          },
                        })}
                        required
                        error={!!errors.descriptorId}
                        helperText={errors.descriptorId?.message}
                        inputProps={{ min: 1 }}
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="weekId"
                    render={() => (
                      <TextField
                        id="weekId"
                        label="Week Id"
                        type="number"
                        variant="outlined"
                        fullWidth
                        {...register("weekId", {
                          min: {
                            value: 1,
                            message: "Week Id must be a positive value",
                          },
                        })}
                        error={!!errors.weekId}
                        helperText={errors.weekId?.message}
                        inputProps={{ min: 1 }}
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="sampleName"
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        id="sampleName"
                        label="Sample Name"
                        variant="outlined"
                        fullWidth
                        {...field}
                        {...register("sampleName")}
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="address"
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        id="address"
                        label="Address"
                        variant="outlined"
                        fullWidth
                        {...field}
                        {...register("address", { required: true })}
                        required
                        error={!!errors.address}
                        helperText={errors.address?.message}
                        InputProps={{
                          endAdornment:
                            isGeolocationEnabled && isGeolocationAvailable ? (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="Populate Location"
                                  onClick={populateLocation}
                                >
                                  <LocationOn />
                                </IconButton>
                              </InputAdornment>
                            ) : (
                              ""
                            ),
                        }}
                      />
                    )}
                  />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Controller
                      control={control}
                      name="setUpDate"
                      render={() => (
                        <DatePicker
                          label="Setup Date"
                          value={setUpDate}
                          onChange={(newValue) => setSetUpDate(newValue)}
                          slotProps={{ textField: { fullWidth: true } }}
                        />
                      )}
                    />
                    <Controller
                      control={control}
                      name="collectionDate"
                      render={() => (
                        <DesktopDatePicker
                          label="Collection Date"
                          value={collectionDate}
                          onChange={(date) => date && setCollectionDate(date)}
                          slotProps={{ textField: { fullWidth: true } }}
                        />
                      )}
                    />
                    <Controller
                      control={control}
                      name="pictureDate"
                      render={() => (
                        <DesktopDatePicker
                          label="Picture Date"
                          value={pictureDate}
                          onChange={(date) => date && setPictureDate(date)}
                          slotProps={{ textField: { fullWidth: true } }}
                        />
                      )}
                    />
                    <Controller
                      control={control}
                      name="hatchingDate"
                      render={() => (
                        <DesktopDatePicker
                          label="Hatching Date"
                          value={hatchingDate}
                          onChange={(date) => date && setHatchingDate(date)}
                          slotProps={{ textField: { fullWidth: true } }}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  <Controller
                    control={control}
                    name="deployTime"
                    render={() => (
                      <TextField
                        id="deployTime"
                        label="Deploy Time (days)"
                        type="number"
                        variant="outlined"
                        fullWidth
                        {...register("deployTime", {
                          required: "Deploy Time is required",
                          min: {
                            value: 1,
                            message: "Deploy Time must be a positive value",
                          },
                        })}
                        required
                        error={!!errors.deployTime}
                        helperText={errors.deployTime?.message}
                        inputProps={{ min: 1 }}
                      />
                    )}
                  />
                </Stack>
              </AccordionDetails>
            </Accordion>

            {/* Optional Fields Section */}
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Additional Options (Optional)</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={2}>
              <Controller
                control={control}
                name="manualEggCount"
                render={() => (
                  <TextField
                    id="manualEggCount"
                    label="Manual Egg Count"
                    type="number"
                    variant="outlined"
                    fullWidth
                    defaultValue={getValues("manualEggCount")}
                    {...register("manualEggCount", {
                      min: {
                        value: 0,
                        message:
                          "Manual Egg Count Time Id must be a positive value",
                      },
                    })}
                  />
                )}
              />
              <Controller
                control={control}
                name="species"
                render={() => (
                  <TextField
                    id="species"
                    label="Species"
                    variant="outlined"
                    fullWidth
                    defaultValue={getValues("species")}
                    {...register("species")}
                  />
                )}
              />
              <Controller
                control={control}
                name="origin"
                render={() => (
                  <TextField
                    id="origin"
                    select
                    label="Origin"
                    placeholder="Origin"
                    fullWidth
                    defaultValue={getValues("origin")}
                    {...register("origin", { required: "Origin is required" })}
                    required
                    error={!!errors.origin}
                    helperText={errors.origin?.message}
                  >
                    {origins.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <Controller
                control={control}
                name="lightCondition"
                render={() => (
                  <TextField
                    id="lightCondition"
                    select
                    label="Light Condition"
                    fullWidth
                    defaultValue={getValues("lightCondition")}
                    {...register("lightCondition", {
                      required: "Light Condition is required",
                    })}
                    required
                    error={!!errors.lightCondition}
                    helperText={errors.lightCondition?.message}
                  >
                    {lightConditions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <Controller
                control={control}
                name="photoCondition"
                render={() => (
                  <TextField
                    id="photoCondition"
                    select
                    label="Photo Condition"
                    fullWidth
                    defaultValue={getValues("photoCondition")}
                    {...register("photoCondition", {
                      required: "Photo Condition is required",
                    })}
                    required
                    error={!!errors.photoCondition}
                    helperText={errors.photoCondition?.message}
                  >
                    {photoConditions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <Controller
                control={control}
                name="paperType"
                render={() => (
                  <TextField
                    id="paperType"
                    select
                    label="Paper Type"
                    fullWidth
                    defaultValue={getValues("paperType")}
                    {...register("paperType", {
                      required: "Paper Type is required",
                    })}
                    required
                    error={!!errors.paperType}
                    helperText={errors.paperType?.message}
                  >
                    {paperTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <Controller
                control={control}
                name="paperColor"
                render={() => (
                  <TextField
                    id="paperColor"
                    label="Paper Color"
                    variant="outlined"
                    fullWidth
                    defaultValue={getValues("paperColor")}
                    {...register("paperColor", {
                      required: "Paper Color is required",
                    })}
                    required
                    error={!!errors.paperColor}
                    helperText={errors.paperColor?.message}
                  />
                )}
              />
              <Controller
                control={control}
                name="paperCondition"
                render={() => (
                  <TextField
                    id="paperCondition"
                    select
                    label="Paper Condition"
                    fullWidth
                    defaultValue={getValues("paperCondition")}
                    {...register("paperCondition", {
                      required: "Paper Condition is required",
                    })}
                    required
                    error={!!errors.paperCondition}
                    helperText={errors.paperCondition?.message}
                  >
                    {paperConditions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <Controller
                control={control}
                name="trapType"
                defaultValue=""
                render={() => (
                  <TextField
                    id="trapType"
                    select
                    label="Trap Type"
                    fullWidth
                    defaultValue={getValues("trapType")}
                    {...register("trapType", {
                      required: "Trap Type is required",
                    })}
                    required
                    error={!!errors.trapType}
                    helperText={errors.trapType?.message}
                  >
                    {trapTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <Controller
                control={control}
                name="waterType"
                render={() => (
                  <TextField
                    id="waterType"
                    select
                    label="Water Type"
                    fullWidth
                    defaultValue={getValues("waterType")}
                    {...register("waterType", {
                      required: "Water Type is required",
                    })}
                    required
                    error={!!errors.waterType}
                    helperText={errors.waterType?.message}
                  >
                    {waterTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <Controller
                control={control}
                name="type"
                defaultValue=""
                render={() => (
                  <TextField
                    id="type"
                    select
                    label="Type"
                    fullWidth
                    defaultValue={getValues("type")}
                    {...register("type", { required: "Type is required" })}
                    required
                    error={!!errors.type}
                    helperText={errors.type?.message}
                  >
                    {types.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <Controller
                control={control}
                name="heightPhoto"
                render={() => (
                  <TextField
                    id="heightPhoto"
                    label="Photo Height"
                    type="number"
                    variant="outlined"
                    fullWidth
                    defaultValue={getValues("heightPhoto")}
                    {...register("heightPhoto", {
                      min: {
                        value: 0,
                        message: "Photo height must be a positive value",
                      },
                    })}
                  />
                )}
              />
              <Controller
                control={control}
                name="stand"
                defaultValue=""
                render={() => (
                  <TextField
                    id="stand"
                    label="Stand"
                    variant="outlined"
                    fullWidth
                    defaultValue={getValues("stand")}
                    {...register("stand")}
                  />
                )}
              />
              <Controller
                control={control}
                name="anglePhoto"
                render={() => (
                  <TextField
                    id="anglePhoto"
                    label="Photo Angle"
                    type="number"
                    variant="outlined"
                    fullWidth
                    defaultValue={getValues("anglePhoto")}
                    {...register("anglePhoto", {
                      min: {
                        value: 0,
                        message: "The photo angle must be 0-360 degrees",
                      },
                      max: {
                        value: 360,
                        message: "The photo angle must be 0-360 degrees",
                      },
                    })}
                  />
                )}
              />
              <Controller
                control={control}
                name="device"
                render={() => (
                  <TextField
                    id="device"
                    label="Device"
                    variant="outlined"
                    fullWidth
                    defaultValue={getValues("device")}
                    {...register("device")}
                  />
                )}
              />
              <Controller
                control={control}
                name="resolution"
                render={() => (
                  <TextField
                    id="resolution"
                    label="Resolution"
                    variant="outlined"
                    fullWidth
                    defaultValue={getValues("resolution")}
                    {...register("resolution")}
                  />
                )}
              />
              <Controller
                control={control}
                name="note"
                render={() => (
                  <TextField
                    id="note"
                    label="Note"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    {...register("note")}
                  />
                )}
              />
                </Stack>
              </AccordionDetails>
            </Accordion>

          {submitError && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {submitError}
            </Alert>
          )}

          {computedEggCount !== null && (
            <Card variant="outlined" sx={{ bgcolor: "success.50" }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Rate Our Prediction
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                  <Typography variant="body1">
                    Detected Eggs: <strong>{computedEggCount}</strong>
                  </Typography>
                  <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />
                  <Box>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      How accurate was this?
                    </Typography>
                    <Rating
                      name="rating"
                      value={rating}
                      onChange={(event, newRating) => {
                        setRating(newRating);
                      }}
                      size="large"
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          )}

          {imagesSubmitted ? (
            <Button 
              type="submit" 
              variant="contained" 
              color="success" 
              size="large"
              fullWidth
              disabled={isSubmitting}
              startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
            >
              {isSubmitting ? "Submitting..." : "Submit Image"}
            </Button>
          ) : (
            <>
              <Button 
                type="submit" 
                disabled 
                variant="contained" 
                color="success" 
                size="large"
                fullWidth
              >
                Submit Image
              </Button>
              <Alert severity="info">
                Please upload and analyze an image first
              </Alert>
            </>
          )}
        </Stack>
      </form>
      </Paper>
    </Container>
  );
};

export default YoloCloudAdd;
